import { render, staticRenderFns } from "./menuSlider.vue?vue&type=template&id=6585f33d&scoped=true"
import script from "./menuSlider.vue?vue&type=script&lang=js"
export * from "./menuSlider.vue?vue&type=script&lang=js"
import style0 from "./menuSlider.vue?vue&type=style&index=0&id=6585f33d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6585f33d",
  null
  
)

export default component.exports